// Registry of the independent public sample boards. Each region is a fully
// self-contained demo dataset (no backend, no writes).
import * as caribbean from "./sampleData.caribbean";
import * as overland from "./sampleData.overland";

export const DATASETS = {
  caribbean: {
    key: "caribbean",
    label: "Caribbean Maritime",
    jobs: caribbean.SAMPLE_JOBS,
    stages: caribbean.SAMPLE_STAGES,
    demoUser: caribbean.DEMO_USER,
  },
  overland: {
    key: "overland",
    label: "US Overland",
    jobs: overland.SAMPLE_JOBS,
    stages: overland.SAMPLE_STAGES,
    demoUser: overland.DEMO_USER,
  },
};
